const experiences = [
  {
    position: 'Web Developer',
    company: 'PT Transporindo Agung Sejahtera',
    startDate: 'Aug 2018 - Present',
    description:
      'Saya bekerja sebagai  web developer,bertugas mengembangkan web dan beberapa aplikasi android'
  },
  {
    position: 'Contract Web Developer',
    company: 'Sisda sumut',
    startDate: 'Okt 2017 - Feb 2018',
    description:
      'Saya bekerja sebagai web developer kontrak,bertugas membantu mengembangkan beberapa aplikasi web dari http://sisda.sumutprov.go.id'
  },
  {
    position: 'Asisten Lab',
    company: 'STMIK Mikroskil',
    startDate: 'Okt 2015 - Okt 2017',
    description:
      'Saya bekerja sebagai asisten lab,bertugas membantu dosen mengarahkan mahasiswa dalam melakukan kegiatan praktek '
  }
];

export default experiences;



// WEBPACK FOOTER //
// ./src/components/data/experiences.js